const InReviewResellerIconSmall = ({ ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="22" height="22" rx="11" fill="#FF9900" />
      <path
        d="M7 6H15L7 16H15L7 6Z"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InReviewResellerIconSmall;
